import z from 'zod'

export const leaveFeedSchema = z.object({
  source: z.string(),
  destination: z.string(),
  programUuid: z.string(),
  masterTaskId: z.string(),
  memberStatus: z.string(),
  taskList: z.array(z.object({
    uuid: z.string(),
    type: z.string(),
  })),
})
